'use strict';

import angular from 'angular';

import autologinComponent from './autologin.component';
import autologin from './autologin.service';
import EmailAutologinController from './email_autologin.controller';
import VerifyEmailController from './verify_email.controller';

export default angular
  .module('autologin', [])
  .directive('saAutologin', autologinComponent)
  .factory('autologin', autologin)
  .controller('EmailAutologinController', EmailAutologinController)
  .controller('VerifyEmailController', VerifyEmailController)
  .name;



// WEBPACK FOOTER //
// ./app/src/modules/autologin/index.js